import API from '../api';
import {
    ICALENDAR_URLS_ENDPOINT,
    ICALENDAR_LOGS_ENDPOINT,
    ICALENDAR_SYNC_ICAL_BY_ID_ENDPOINT,
    ICALENDAR_SYNC_ALL_ICAL_ENDPOINT,
} from '../endpoints';
import { WebSocketClient } from '../websocket/client';


export default {
    namespaced: true,

    state() {
        return {
            urls: [],
            websocketToken: null,
        };
    },
    mutations: {
        setWebsocketToken(state, value) {
           state.websocketToken = value;
        },        
        setUrls(state, {data}) {
            state.urls = data.map((item, index) => {
                return { ...item, index: index + 1 };
            });
        },
    },
    actions: {
        async fetchUrls({commit}) {
            commit('setUrls', await API.get(ICALENDAR_URLS_ENDPOINT()));
        },
        async syncCalendar({state}) {
           await API.post(ICALENDAR_SYNC_ALL_ICAL_ENDPOINT(), {websocket_token: state.websocketToken});
        },
        async syncCalendarById({commit, state}, id) {
           await API.post(ICALENDAR_SYNC_ICAL_BY_ID_ENDPOINT(id), {websocket_token: state.websocketToken});
        },

    }
};